"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.OptOutType = exports.Realm = exports.NotificationAction = exports.Provider = exports.NotificationStatus = exports.NotificationType = void 0;
var NotificationType;
(function (NotificationType) {
    NotificationType["EMAIL"] = "EMAIL";
    NotificationType["SMS"] = "SMS";
    NotificationType["PUSH"] = "PUSH";
})(NotificationType = exports.NotificationType || (exports.NotificationType = {}));
var NotificationStatus;
(function (NotificationStatus) {
    NotificationStatus["CREATED"] = "CREATED";
    NotificationStatus["PENDING"] = "PENDING";
    NotificationStatus["FAILED"] = "FAILED";
    NotificationStatus["RESENT"] = "RESENT";
    NotificationStatus["OPT_IN"] = "OPT_IN";
    NotificationStatus["OPT_OUT"] = "OPT_OUT";
    NotificationStatus["SCHEDULED"] = "SCHEDULED";
    NotificationStatus["CANCELLED"] = "CANCELLED";
    NotificationStatus["PROCESSED"] = "PROCESSED";
    NotificationStatus["DROPPED"] = "DROPPED";
    NotificationStatus["DELIVERED"] = "DELIVERED";
    NotificationStatus["DEFERRED"] = "DEFERRED";
    NotificationStatus["BOUNCE"] = "BOUNCE";
    NotificationStatus["BLOCKED"] = "BLOCKED";
    NotificationStatus["OPEN"] = "OPEN";
    NotificationStatus["CLICK"] = "CLICK";
    NotificationStatus["SPAM_REPORT"] = "SPAMREPORT";
    NotificationStatus["SPAMREPORT"] = "SPAMREPORT";
    NotificationStatus["UNSUBSCRIBE"] = "UNSUBSCRIBE";
    NotificationStatus["GROUP_UNSUBSCRIBE"] = "GROUP_UNSUBSCRIBE";
    NotificationStatus["GROUP_RESUBSCRIBE"] = "GROUP_RESUBSCRIBE";
    NotificationStatus["ACCEPTED"] = "ACCEPTED";
    NotificationStatus["QUEUED"] = "QUEUED";
    NotificationStatus["SENDING"] = "SENDING";
    NotificationStatus["SENT"] = "SENT";
    NotificationStatus["UNDELIVERED"] = "UNDELIVERED";
    NotificationStatus["RECEIVING"] = "RECEIVING";
    NotificationStatus["RECEIVED"] = "RECEIVED";
})(NotificationStatus = exports.NotificationStatus || (exports.NotificationStatus = {}));
var Provider;
(function (Provider) {
    Provider["SENDGRID"] = "SENDGRID";
    Provider["TWILIO"] = "TWILIO";
    Provider["FIREBASE"] = "FIREBASE";
})(Provider = exports.Provider || (exports.Provider = {}));
var NotificationAction;
(function (NotificationAction) {
    NotificationAction["CREATED"] = "CREATED";
    NotificationAction["UPDATED"] = "UPDATED";
    NotificationAction["IDENTITY_CHANGED"] = "IDENTITY_CHANGED";
    NotificationAction["DELETED"] = "DELETED";
})(NotificationAction = exports.NotificationAction || (exports.NotificationAction = {}));
var Realm;
(function (Realm) {
    Realm["User"] = "User";
    Realm["Machine"] = "Machine";
    Realm["Internal"] = "Internal";
    Realm["Partner"] = "Partner";
    Realm["GroupAdmin"] = "GroupAdmin";
})(Realm = exports.Realm || (exports.Realm = {}));
var OptOutType;
(function (OptOutType) {
    OptOutType["START"] = "START";
    OptOutType["STOP"] = "STOP";
    OptOutType["HELP"] = "HELP";
})(OptOutType = exports.OptOutType || (exports.OptOutType = {}));
const axios_1 = __importDefault(require("axios"));
const utils_1 = require("../../utils");
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://notifications.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Notifications
 * @version v1
 * @baseUrl https://notifications.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags Email
             * @name EmailSendEmail
             * @request POST:/v1/sendEmail
             * @deprecated
             * @secure
             */
            emailSendEmail: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/sendEmail`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Notification
             * @name NotificationGetNotificationsByIdentityId
             * @request GET:/v1/identities/{identityId}/notifications
             * @secure
             */
            notificationGetNotificationsByIdentityId: (identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/notifications`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Notification
             * @name NotificationCreateNotificationsByIdentityId
             * @request POST:/v1/identities/{identityId}/notifications
             * @secure
             */
            notificationCreateNotificationsByIdentityId: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/notifications`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Notification
             * @name NotificationChangeIdentity
             * @request POST:/v1/identities/{identityId}/notifications/{notificationId}/changeIdentity
             * @secure
             */
            notificationChangeIdentity: (identityId, notificationId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/notifications/${notificationId}/changeIdentity`, method: 'POST', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Notification
             * @name NotificationRemoveNotification
             * @request DELETE:/v1/identities/{identityId}/notifications/{notificationId}
             * @secure
             */
            notificationRemoveNotification: (identityId, notificationId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/notifications/${notificationId}`, method: 'DELETE', secure: true }, params)),
            /**
             * No description
             *
             * @tags Notification
             * @name NotificationSendOtpNotification
             * @request POST:/v1/identities/{identityId}/sendOtp
             * @secure
             */
            notificationSendOtpNotification: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/sendOtp`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Notification
             * @name NotificationSendNotification
             * @request POST:/v1/sendNotification
             * @secure
             */
            notificationSendNotification: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/sendNotification`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Notification
             * @name NotificationResendNotification
             * @request POST:/v1/notifications/{notificationId}/resend
             * @secure
             */
            notificationResendNotification: (notificationId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/notifications/${notificationId}/resend`, method: 'POST', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Notification
             * @name NotificationCancelScheduledNotification
             * @request POST:/v1/notifications/{notificationId}/cancelScheduled
             * @secure
             */
            notificationCancelScheduledNotification: (notificationId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/notifications/${notificationId}/cancelScheduled`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Notification
             * @name NotificationUpdateDeliverOnDate
             * @request POST:/v1/notifications/{notificationId}/updateDeliverOn
             * @secure
             */
            notificationUpdateDeliverOnDate: (notificationId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/notifications/${notificationId}/updateDeliverOn`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Notification
             * @name NotificationProcessScheduledNotification
             * @request POST:/v1/notifications/{notificationId}/processScheduled
             * @secure
             */
            notificationProcessScheduledNotification: (notificationId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/notifications/${notificationId}/processScheduled`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags NotificationsJournal
             * @name NotificationsJournalGetJournalChanges
             * @request GET:/v1/notifications/journal
             * @secure
             */
            notificationsJournalGetJournalChanges: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/notifications/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags NotificationsJournal
             * @name NotificationsJournalGetJournalMaxClock
             * @request GET:/v1/notifications/journal/maxClock
             * @secure
             */
            notificationsJournalGetJournalMaxClock: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/notifications/journal/maxClock`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags NotificationsTemplates
             * @name NotificationsTemplatesGetTemplates
             * @request GET:/v1/notifications/templates
             * @secure
             */
            notificationsTemplatesGetTemplates: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/notifications/templates`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags NotificationsTemplates
             * @name NotificationsTemplatesCreateTemplateResource
             * @request POST:/v1/notifications/templates
             * @secure
             */
            notificationsTemplatesCreateTemplateResource: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/notifications/templates`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags NotificationsTemplates
             * @name NotificationsTemplatesGetTemplatesForKey
             * @request GET:/v1/notifications/templates/{key}
             * @secure
             */
            notificationsTemplatesGetTemplatesForKey: (key, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/notifications/templates/${key}`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags NotificationsTemplates
             * @name NotificationsTemplatesAddLocalizedTemplate
             * @request PUT:/v1/notifications/templates/{templateKey}/{templateType}/{templateLocale}
             * @secure
             */
            notificationsTemplatesAddLocalizedTemplate: (templateKey, templateType, templateLocale, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/notifications/templates/${templateKey}/${templateType}/${templateLocale}`, method: 'PUT', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags NotificationsTemplates
             * @name NotificationsTemplatesRemoveLocalizedTemplate
             * @request DELETE:/v1/notifications/templates/{templateKey}/{templateType}/{templateLocale}
             * @secure
             */
            notificationsTemplatesRemoveLocalizedTemplate: (templateKey, templateType, templateLocale, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/notifications/templates/${templateKey}/${templateType}/${templateLocale}`, method: 'DELETE', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags NotificationsTemplates
             * @name NotificationsTemplatesRemoveTemplateResource
             * @request DELETE:/v1/notifications/templates/{templateKey}
             * @secure
             */
            notificationsTemplatesRemoveTemplateResource: (templateKey, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/notifications/templates/${templateKey}`, method: 'DELETE', secure: true }, params)),
            /**
             * No description
             *
             * @tags Template
             * @name TemplateGetTemplates
             * @request GET:/v1/templates
             * @secure
             */
            templateGetTemplates: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/templates`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Template
             * @name TemplateGetTemplatesForKey
             * @request GET:/v1/templates/{key}
             * @secure
             */
            templateGetTemplatesForKey: (key, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/templates/${key}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Webhook
             * @name WebhookProcessSendGridWebhookEvent
             * @request POST:/v1/sendgrid/events
             * @secure
             */
            webhookProcessSendGridWebhookEvent: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/sendgrid/events`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Webhook
             * @name WebhookProcessTwilioWebhookEvent
             * @request POST:/v1/twilio/events
             * @secure
             */
            webhookProcessTwilioWebhookEvent: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/twilio/events`, method: 'POST', body: data, secure: true, type: FecContentType.FormData, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Webhook
             * @name WebhookProcessTwilioSmsWebhook
             * @request POST:/v1/twilio/sms
             * @secure
             */
            webhookProcessTwilioSmsWebhook: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/twilio/sms`, method: 'POST', body: data, secure: true, type: FecContentType.FormData }, params)),
        };
    }
}
exports.Api = Api;
//# sourceMappingURL=notifications.js.map